import { WorkflowApprovalRowDto } from "../../types/workflowDto";

/**
 * Epic 80431 (Pooja Pujara, 2026-10-19) - a Builder test run routes every step to its tester, and
 * the Run screen says who the step would really have gone to: "Creator's manager (Jane Doe),
 * assigned to you for this test run".
 */
export const TEST_RUN_ASSIGNED_SUFFIX = "assigned to you for this test run";

/** The routing line for a test-run step. The label is the role the rule names; the name is optional. */
export const testRunAssigneeText = (label: string, name?: string | null): string =>
  `${name ? `${label} (${name})` : label}, ${TEST_RUN_ASSIGNED_SUFFIX}`;

/** An approver as the Approval stage names them: the intended person on a test run, else the approver. */
export const approverDisplayName = (row: WorkflowApprovalRowDto): string =>
  row.intendedLabel ? testRunAssigneeText(row.intendedLabel, row.intendedName) : row.approverName || "Approver";

export const TEST_RUN_NOTICE =
  "Test run - every step is assigned to you, e-mails go only to you, and web services are not called.";
export const DISCARD_TEST_RUN_TITLE = "Discard test run";
export const DISCARD_TEST_RUN_MESSAGE =
  "Discard this test run? The case and every open task and approval on it are cancelled.";
export const TEST_RUN_DISCARDED = "Test run discarded";
export const TEST_RUN_NOT_DISCARDED = "The test run couldn't be discarded.";
